const messages = {
  es: {
    translations: {
      signup: {
        title: "Registrarse",
        toasts: {
          success: "¡Usuario creado con éxito! ¡Por favor inicie sesión!",
          fail: "Error al crear usuario. Por favor verifique los datos proporcionados.",
        },
        form: {
          name: "Nombre",
          email: "Email",
          password: "Contraseña",
          companyName: "Nombre de la Empresa",
          companyNamePlaceholder: "Escriba el nombre de su empresa",
          phone: "Teléfono",
          phonePlaceholder: "(00) 00000-0000",
          passwordPlaceholder: "Mínimo 5 caracteres",
          emailPlaceholder: "tu@email.com",
        },
        buttons: {
          submit: "Registrarse",
          register: "Registrarse",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
          creating: "Creando cuenta...",
          startTrial: "Comenzar prueba de {{days}} días",
          selected: "Seleccionado",
          select: "Seleccionar",
          backToPlans: "Volver a los planes",
          loginHere: "Inicia sesión aquí",
        },
        validation: {
          passwordTooShort: "¡Contraseña demasiado corta! Mínimo 5 caracteres",
          nameTooShort: "¡Nombre demasiado corto!",
          nameTooLong: "¡Nombre demasiado largo!",
          passwordTooLong: "¡Contraseña demasiado larga!",
          invalidEmail: "Email inválido",
          phoneIncomplete: "Número de teléfono incompleto",
          required: "Requerido",
        },
        steps: {
          selectPlan: "Seleccione su plan",
          createAccount: "Cree su cuenta",
        },
        hero: {
          title: "Comience ahora su viaje digital.",
          subtitle: "Únase a cientos de empresas que ya han transformado su servicio con {{appName}}.",
        },
        planCard: {
          popular: "POPULAR",
          perMonth: "/mes",
          whatsappConnections: "Conexiones de WhatsApp",
          users: "Usuarios",
          prioritySupport: "Soporte prioritario",
          freeDays: "{{days}} días gratis",
          selectedPlan: "Plan seleccionado:",
        },
        welcomeText: "¡Bienvenido!",
        formTitle: "Cree su cuenta",
        formSubtitle: "Pruébalo gratis durante {{days}} días.",
        planSelectionTitle: "Elija el melhor plan para usted:",
        links: {
          agree: "Al registrarse, acepta nuestros",
          terms: "Términos de Servicio",
          privacy: "Política de Privacidad",
          and: "y",
        },
        alreadyHaveAccount: "¿Ya tienes una cuenta?",
      },
      login: {
        title: "Iniciar Sesión",
        formTitle: "Acceda a su cuenta",
        formSubtitle: "Siga sus conversaciones en tiempo real.",
        hero: {
          title: "¡Bienvenido de nuevo!",
          subtitle: "Conéctese con sus clientes de forma inteligente y eficiente.",
        },
        form: {
          email: "Email",
          password: "Contraseña",
        },
        placeholders: {
          email: "tu@email.com",
          password: "••••••••",
        },
        buttons: {
          submit: "Entrar",
          register: "¡Regístrate ahora!",
          createAccount: "Crear cuenta",
        },
        links: {
          forgotPassword: "¿Olvidó su contraseña?",
          noAccount: "¿No tienes una cuenta?",
        },
      },
      forgetPassword: {
        title: "Restablecer contraseña",
        hero: {
          title: "No te preocupes.",
          subtitle: "Recuperar el acceso a tu cuenta es sencillo y rápido. Sigue las instrucciones al lado.",
        },
        formTitle: "Recuperar cuenta",
        formSubtitle: "Introduce tu correo electrónico para recibir las instrucciones de recuperación.",
        resetFormSubtitle: "Crea una nueva contraseña para tu cuenta.",
        form: {
          email: "Email",
          verificationCode: "Código de Verificação",
          newPassword: "Nueva contraseña",
          confirmPassword: "Confirmar contraseña",
        },
        buttons: {
          resetPassword: "Restablecer Contraseña",
          sendEmail: "Enviar Email",
        },
        links: {
          noAccount: "¿No tienes una cuenta?",
          backToLogin: "Volver al inicio de sesión",
        },
        messages: {
          emailNotFound: "Email no encontrado",
          emailSentSuccess: "¡Email enviado con éxito!",
          passwordResetSuccess: "Contraseña restablecida con éxito.",
          requiredField: "Campo obligatorio",
          passwordsDontMatch: "Las contraseñas no coinciden",
          passwordRequirements: "Su contraseña debe tener al menos 8 caracteres, incluyendo una letra mayúscula, una minúscula y un número.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Agendamientos",
          enabled: "Habilitado",
          disabled: "Deshabilitado",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "$",
        },
      },
      cookieConsent: {
        title: "Preferencias de cookies",
        subtitle: "Personalice qué categorías de cookies permite. Puede cambiar esta decisión en cualquier momento.",
        message: "Utilizamos cookies e tecnologias similares para mejorar su experiencia en nuestros servicios, personalizar la publicidad y recomendar contenido de su interés.",
        disclaimer: "Al confirmar, registramos la fecha/hora de su consentimiento según lo exigido por las regulaciones de protección de datos (RGPD/LGPD).",
        buttons: {
          acceptAll: "Aceptar todos",
          decline: "Rechazar no esenciales",
          configure: "Configurar preferencias",
          save: "Guardar mis elecciones",
          close: "Cerrar",
        },
        categories: {
          essential: {
            title: "Esenciales",
            description: "Necesarias para la autenticación, la seguridad y el funcionamiento básico. No se pueden desactivar.",
          },
          analytics: {
            title: "Analíticas",
            description: "Ayudan a entender cómo utiliza la plataforma para que podamos mejorar el producto. Ej.: Google Analytics.",
          },
          marketing: {
            title: "Marketing",
            description: "Permiten campañas y remarketing personalizados. Ej.: píxeles de redes sociales.",
          },
          functional: {
            title: "Funcionales",
            description: "Recuerdan sus preferencias (tema, idioma, diseño) para personalizar la experiencia.",
          },
        },
        policyLink: "Ver Política de Privacidad",
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        token: "Token",
      },
      connections: {
        title: "Conexiones",
        subtitle: "Todos los WhatsApps",
        status: {
          connected: "Conectado",
          disconnected: "Desconectado",
          qrcode: "Código QR",
          timeout: "Tiempo agotado",
          connecting: "Conectando",
        },
        labels: {
          default: "Predeterminado",
          numberNotDefined: "Número no definido",
          connections: "conexiones",
        },
        toasts: {
          deleted: "¡Conexión de WhatsApp eliminada con éxito!",
          disconnected: "¡Conexión desconectada con éxito!",
          connecting: "Conectando...",
          requestingQr: "Solicitando nuevo Código QR...",
          restarting: "Por favor espere... reiniciando...",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? Esta acción no se puede deshacer.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Está seguro? Tendrá que leer el Código QR nuevamente.",
        },
        buttons: {
          add: "Agregar WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Intentar de nuevo",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          connecting: "Conectando",
          restart: "Reiniciar",
          edit: "Editar",
          delete: "Eliminar",
        },
        emptyState: {
          title: "No se encontraron conexiones",
          message: 'Haga clic en el botón "Agregar Conexión" para comenzar',
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión de WhatsApp",
            content: "Asegúrese de que su teléfono esté conectado a internet e intente nuevamente, o solicite un nuevo Código QR",
          },
          qrcode: {
            title: "Esperando lectura del Código QR",
            content: "Haga clic en el botón 'CÓDIGO QR' y escanee el código con su teléfono para iniciar la sesión",
          },
          connected: {
            title: "¡Conexión establecida!",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono",
            content: "Asegúrese de que su teléfono esté conectado a internet y WhatsApp esté abierto, o haga clic en 'Desconectar' para obtener un nuevo Código QR",
          },
        },
        table: {
          name: "Nombre",
          number: "Número",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agregar WhatsApp",
          edit: "Editar WhatsApp",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario comercial",
        },
        form: {
          name: "Nombre",
          default: "Predeterminado",
          sendIdQueue: "Cola",
          timeSendQueue: "Redirigir a la cola en X minutos",
          queueRedirection: "Redirección de Cola",
          outOfHoursMessage: "Mensaje fuera de horario",
          queueRedirectionDesc: "Seleccione una cola para redirigir a los contactos sin cola",
          prompt: "Prompt",
          greetingMedia: "Medios de Bienvenida (Opcional)",
          attachImage: "Adjuntar Imagen",
          transferAfterMinutes: "Transferir después de x (minutos)",
          transferQueue: "Cola de Transferencia",
          expiresTicket: "Cerrar chats abiertos después de X horas",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          //maxUseBotQueues: "Enviar bot x veces",
          //timeUseBotQueues: "Intervalo en minutos entre envíos del bot",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de finalización",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado con éxito.",
      },
      qrCode: {
        message: "Escanee el Código QR para iniciar la sesión",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto eliminado con éxito!",
          deletedAll: "¡Todos los contactos eliminados con éxito!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          importTitle: "Importar contactos",
          deleteMessage: "¿Está seguro de que desea eliminar este contacto? Todos los tickets relacionados se perderán.",
          deleteAllMessage: "¿Está seguro de que desea eliminar todos los contactos? Todos los tickets relacionados se perderán.",
          importMessage: "Esta acción importará los contactos guardados en WhatsApp. ¡Algunos modelos pueden no permitir esta funcionalidad o depender de su configuración de privacidad! Verifique el resultado dentro de 1 hora.",
        },
        buttons: {
          import: "Importar Contactos",
          importSheet: "Importar Excel",
          add: "Agregar Contacto",
          export: "Exportar Contactos",
          delete: "Eliminar Todos los Contactos",
          selectAll: "Seleccionar Todos",
          deselectAll: "Deseleccionar Todos",
          deleteSelected: "Eliminar",
          deleteAllSelected: "Eliminar Todos",
          importExport: "Importar / Exportar",
          exportExcel: "Exportar Excel",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Acciones",
          profilePicture: "Foto de Perfil",
          lastInteraction: "Última Interacción",
          status: "Estado",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "ContenidoJson",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra clave para finalizar el ticket",
          typebotKeywordRestart: "Palabra clave para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración probada con éxito!",
          addSuccess: "Integración agregada con éxito.",
          editSuccess: "Integración editada con éxito.",
        },
      },
      sideMenu: {
        name: "Menú Lateral Inicial",
        note: "Si está habilitado, el menú lateral iniciará cerrado",
        options: {
          enabled: "Abierto",
          disabled: "Cerrado",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en respuesta",
          temperature: "Temperatura",
          apikey: "Clave API",
          max_messages: "Máximo de mensajes en Historial",
          voiceKey: "Clave API de Voz",
          voiceRegion: "Región de Voz",
        },
        validation: {
          nameTooShort: "¡Demasiado corto!",
          nameTooLong: "¡Demasiado largo!",
          nameRequired: "Requerido",
          promptTooShort: "¡Demasiado corto!",
          promptRequired: "Describa el entrenamiento para la Inteligencia Artificial",
          voiceRequired: "Ingrese el modo de voz",
          maxTokensRequired: "Ingrese el número máximo de tokens",
          temperatureRequired: "Ingrese la temperatura",
          apikeyRequired: "Ingrese la Clave API",
          queueIdRequired: "Ingrese la cola",
          maxMessagesRequired: "Ingrese el número máximo de mensajes",
        },
        voices: {
          text: "Texto",
          francisca: "Francisca",
          antonio: "Antonio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fabio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Leticia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valerio",
          yara: "Yara",
        },
        success: "¡Prompt guardado con éxito!",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Departamento/Cola",
          max_tokens: "Máx Tokens Respuesta",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no se puede deshacer!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
        warning: {
          title: "Aviso Importante:",
          message: "Para todos los usuarios de Whaticket que notaron una interrupción en el funcionamiento de OpenAI, nos gustaría aclarar que esto no es un error del sistema. OpenAI ofrece un crédito gratuito de $5 USD para nuevos registros, sin embargo, este beneficio también está sujeto a un límite de tiempo, generalmente alrededor de tres meses. Cuando el crédito disponible se agota, es necesario recargar la cuenta para continuar usando el servicio. Es importante estar al tanto de esta política para garantizar una experiencia continua e ininterrumpida en el uso de OpenAI con Whaticket. Si notó que el servicio dejó de funcionar, verifique si su crédito gratuito ha expirado y considere recargar la cuenta si es necesario. Estamos disponibles para ayudar y aclarar cualquier duda adicional que pueda surgir. Gracias por su comprensión y continuaremos trabajando para ofrecer el mejor servicio posible a nuestros usuarios.",
          usefulLinks: "Enlaces Útiles:",
          usage: "Uso:",
          billing: "Facturación:",
          api: "API:",
        },
        toasts: {
          noPermission: "¡Esta empresa no tiene permiso para acceder a esta página! Lo estamos redirigiendo.",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Email",
          emailPlaceholder: "tu@email.com",
          birthday: "Cumpleaños",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          disableBot: "Deshabilitar chatbot",
          whatsapp: "Conexión de Origen: ",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        validation: {
          nameRequired: "Requerido",
          nameTooShort: "¡Demasiado corto! Mínimo 2 caracteres",
          nameTooLong: "¡Demasiado largo! Máximo 50 caracteres",
          numberRequired: "Ingrese el número",
          numberInvalid: "Número inválido",
          emailInvalid: "Email inválido",
        },
        success: "Contacto guardado con éxito.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        tabs: {
          queueData: "Datos de la Cola",
          serviceHours: "Horario de Atención",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de finalización",
          outOfHoursMessage: "Mensaje fuera de horario",
          ratingMessage: "Mensaje de evaluación",
          token: "Token",
          orderQueue: "Orden de cola (Bot)",
          integrationId: "Integración",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          attach: "Adjuntar Archivo",
        },
        serviceHours: {
          dayWeek: "Día de la semana",
          startTimeA: "Hora Inicio - 1",
          endTimeA: "Hora Fin - 1",
          startTimeB: "Hora Inicio - 2",
          endTimeB: "Hora Fin - 2",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      qrCodeModal: {
        title: "QrCode",
        waiting: "Esperando generación del Código QR...",
        instructions: {
          title: "Cómo conectar su WhatsApp:",
          step1: {
            number: "1.",
            text: "Abra WhatsApp en su teléfono",
          },
          step2: {
            number: "2.",
            text: "Toque Más opciones en Android o Configuración en iPhone",
          },
          step3: {
            number: "3.",
            text: "Toque Dispositivos Vinculados y luego Vincular un Dispositivo",
          },
          step4: {
            number: "4.",
            text: "Apunte la cámara de su teléfono a esta pantalla para escanear el Código QR",
          },
          note: "El Código QR se actualiza automáticamente cada 60 segundos",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Email",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión Predeterminada",
          SuperIs: 'ESTABLECER SUPERUSUARIO (Solo Admin)',
          allTicket: "Ticket Sin Cola [Invisible]",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Deshabilitado",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado con éxito.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Agendamiento",
          edit: "Editar Agendamiento",
        },
        form: {
          body: 'Mensaje',
          contact: 'Contacto',
          sendAt: 'Fecha de Agendamiento',
          sentAt: 'Fecha de Envío',
          geral: '¿Abrir Ticket?',
          sendBy: "Enviar por...",
        },
        recurrence: {
          day: "día",
          days: "días",
          everyDay: "Todos los días",
          daysOfWeek: {
            sunday: "Domingo",
            monday: "Lunes",
            tuesday: "Martes",
            wednesday: "Miércoles",
            thursday: "Jueves",
            friday: "Viernes",
            saturday: "Sábado",
          },
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          attachMedia: "Adjuntar Medios",
        },
        success: "Agendamiento guardado con éxito.",
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Etiqueta guardada con éxito.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTRE Y SUELTE ARCHIVOS EN EL CAMPO DE ABAJO",
          titleFileList: "Lista de archivos",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
          closeallTicket: "Cerrar",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Colas",
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SÍ",
          no: "NO",
          open: "Abierto",
          resolverd: "Resuelto",
        },
        toasts: {
          deleted: "El ticket en el que estaba fue eliminado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: {
            title: "Abierto"
          },
          closed: {
            title: "Resuelto"
          },
          search: {
            title: "Buscar"
          },
        },
        search: {
          placeholder: "Buscar tickets y mensajes",
          filterConnections: "Filtrar por conexiones",
          filterContacts: "Filtrar por contacto",
          filterConections: "Filtrar por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtrar por Usuarios",
          filterTags: "Filtrar por Etiquetas",
          filterStatus: "Filtrar por Estado",
          ticketsPerPage: "Tickets por página",
          groups: "Grupos",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a cola",
        fieldQueuePlaceholder: "Seleccione una cola",
        noOptions: "No se encontró usuario con este nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        called: "Ticket",
        pendingHeader: "Pendiente",
        assignedHeader: "Atendiendo",
        noTicketsTitle: "¡Nada por aquí!",
        noTicketsMessage: "No se encontró ningún ticket con este estado o término de búsqueda",
        buttons: {
          accept: "Aceptar",
          closed: "Finalizar",
          transfer: "Transferir",
          reopen: "Reabrir",
          exportAsPDF: "Exportar a PDF",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escriba para buscar contacto",
        add: "Agregar",
        selectQueue: "Seleccione una cola",
        selectConnection: "Seleccione una Conexión",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        sections: {
          atendimento: "Servicio",
          gerencia: "Gestión",
          campanhas: "Campañas",
          administracao: "Administración",
          sistema: "Sistema",
        },
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          kanban: "Kanban",
          queues: "Colas y Chatbot",
          tags: "Etiquetas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Agendamientos",
          campaigns: "Campañas",
          listagem: "Listado",
          contactLists: "Listas de Contactos",
          campaignsConfig: "Configuración",
          annoucements: "Anuncios",
          backups: "Respaldos",
          tasks: "Tareas",
          chats: "Chat Interno",
          financeiro: "Finanzas",
          files: "Lista de archivos",
          prompts: "OpenAI",
          reports: "Informes",
          queueIntegration: "Integraciones",
        },
        appBar: {
          notRegister: "Sin notificaciones",
          user: {
            profile: "Perfil",
            logout: "Cerrar sesión",
          },
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Última actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no se puede deshacer! y se eliminará de las colas y conexiones vinculadas",
        },
      },
      reports: {
        title: "Informes de Tickets",
        labels: {
          contact: "Contacto",
          dateFrom: "Fecha Inicial",
          dateTo: "Fecha Final",
        },
        tooltips: {
          exportExcel: "Exportar a Excel",
          accessTicket: "Acceder al Ticket",
        },
        status: {
          open: "ABIERTO",
          closed: "CERRADO",
          pending: "PENDIENTE",
          noQueue: "SIN COLA",
        },
        messages: {
          noPermissionFilterUsers: "No tiene permiso para filtrar tickets de otros usuarios",
        },
        excel: {
          sheetName: "InformesDeTickets",
          fileName: "informes-tickets.xlsx",
        },
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Último Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Soporte",
        },
        buttons: {
          filter: "Aplicar Filtro",
        },
        searchPlaceholder: "Buscar...",
      },
      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "¡Lista eliminada con éxito!",
          deletedAll: "¡Todas las listas eliminadas con éxito!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todo",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todo",
          deleteMessage: "¿Está seguro de que desea eliminar esta lista?",
          deleteAllMessage: "¿Está seguro de que desea eliminar todas las listas?",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
      },
      messagesAPI: {
        title: "Documentación de envío de mensajes",
        sections: {
          sendMethods: "Métodos de Envío",
          textMessages: "Mensajes de Texto",
          mediaMessages: "Mensajes Multimedia",
          instructions: "Instrucciones",
          textMessagesTitle: "1. Mensajes de Texto",
          mediaMessagesTitle: "2. Mensajes Multimedia",
          testSend: "Envío de Prueba",
        },
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          description: "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          endpoint: "Endpoint",
          method: "Método",
          headers: "Encabezados",
          headersValue: "Authorization (Bearer token) y Content-Type (application/json)",
          bodyExample: "Su mensaje",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
          description: "A continuación se muestra la lista de información necesaria para enviar mensajes multimedia:",
          endpoint: "Endpoint",
          method: "Método",
          headers: "Encabezados",
          headersValue: "Authorization (Bearer token) y Content-Type (multipart/form-data)",
          formData: "FormData",
          file: "archivo",
          selectFile: "Ningún archivo seleccionado",
        },
        buttons: {
          send: "Enviar",
        },
        toasts: {
          messageSent: "Mensaje enviado con éxito",
        },
        notes: {
          title: "Notas importantes",
          tokenNote: "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. Para registrarse, acceda al menú \"Conexiones\", haga clic en el botón editar de la conexión e ingrese el token en el campo correspondiente.",
          numberFormat: "El número para el envío no debe tener máscara ni caracteres especiales y debe estar compuesto por:",
          countryCode: "Código de país",
          areaCode: "Código de área",
          number: "Número",
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin adjunto",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¡Esta acción es irreversible! ¿Desea proceder?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "¡Atajo agregado con éxito!",
          deleted: "¡Atajo eliminado con éxito!",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visualización",
          active: "Activo",
          inactive: "Inactivo",
          editBeforeSend: "Editar antes de enviar",
        },
        validation: {
          required: "Obligatorio",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del archivo",
          status: 'Global',
        },
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
        },
      },
      dashboard: {
        cards: {
          activeConnections: "Conexiones Activas",
          companies: "Empresas",
          inConversation: "En Conversación",
          waiting: "Esperando",
          newContacts: "Nuevos Contactos",
          avgConversationTime: "T.M. de Conversación",
          finished: "Finalizados",
          avgWaitTime: "T.M. de Espera",
        },
        filters: {
          filterType: "Tipo de Filtro",
          dateFilter: "Filtro por Fecha",
          periodFilter: "Filtro por Período",
          dateFrom: "Fecha Inicial",
          dateTo: "Fecha Final",
          period: "Período",
          noneSelected: "Ninguno seleccionado",
          last3Days: "Últimos 3 días",
          last7Days: "Últimos 7 días",
          last15Days: "Últimos 15 días",
          last30Days: "Últimos 30 días",
          last60Days: "Últimos 60 días",
          last90Days: "Últimos 90 días",
          filter: "Filtrar",
        },
        messages: {
          parameterizeFilter: "Configure los parámetros del filtro",
        },
        charts: {
          ticketsCreated: "Tickets Creados: ",
          tickets: "Tickets",
          conversationsChart: "Gráfico de Conversaciones",
          quantity: "Cantidad",
          hourOfDay: "Hora del Día",
          errorLoadingData: "Error al obtener información de los tickets",
        },
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lista",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Buscar",
        buttons: {
          add: "Nuevo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
          importMessage: "¿Desea importar contactos de esta hoja? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Buscar",
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de Contactos",
          stopCampaign: "Detener Campaña",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de Contactos",
          status: "Estado",
          scheduledAt: "Programación",
          completedAt: "Completado",
          confirmation: "Confirmación",
          actions: "Acciones",
          notDefinedQueue: "No definido",
          notDefinedWhatsapp: "No definido",
          noSchedule: "Sin programación",
          notCompleted: "No completado",
          statusInactive: "Inactivo",
          statusScheduled: "Programado",
          statusInProgress: "En Progreso",
          statusCancelled: "Cancelado",
          statusFinished: "Finalizado",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Ver",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programación",
            confirmation: "Confirmación",
            contactList: "Lista de Contactos",
            tagList: "Lista de Etiquetas",
            fileList: "Lista de Archivos",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación exitosa",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro eliminado",
        },
      },
      announcements: {
        active: 'Activo',
        inactive: 'Inactivo',
        title: "Anuncios",
        searchPlaceholder: "Buscar",
        priority: {
          high: "Alta",
          average: "Media",
          low: "Baja",
        },
        buttons: {
          add: "Nuevo Anuncio",
          contactLists: "Listas de Anuncios",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Anuncio",
          add: "Nuevo Anuncio",
          update: "Editar Anuncio",
          readonly: "Solo Ver",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación exitosa",
          deleted: "Registro eliminado",
        },
      },
      queues: {
        title: "Colas y Chatbot",
        table: {
          id: "ID",
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de bienvenida",
          actions: "Acciones",
          orderQueue: "Orden de cola (bot)",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no se puede deshacer! Los tickets en esta cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Colas",
      },
      users: {
        title: "Usuarios",
        table: {
          id: "ID",
          name: "Nombre",
          status: "Estado",
          email: "Email",
          profile: "Perfil",
          actions: "Acciones",
        },
        status: {
          online: "Usuarios en línea",
          offline: "Usuarios desconectados",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario eliminado con éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos del usuario se perderán. Los tickets abiertos de este usuario se moverán a la cola.",
        },
      },
      helps: {
        title: "Centro de Ayuda",
      },
      schedules: {
        title: "Agendamientos",
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "¿Está seguro de que desea eliminar este Agendamiento?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de Agendamiento",
          sentAt: "Fecha de Envío",
          status: "Estado",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Agendamiento",
        },
        tooltips: {
          edit: "Editar",
          delete: "Eliminar",
        },
        toasts: {
          deleted: "Agendamiento eliminado con éxito.",
        },
        messages: {
          noEventsInRange: "No hay agendamientos en este período.",
        },
        calendar: {
          month: "Mes",
          next: "Siguiente",
          tomorrow: "Mañana",
          previous: "Anterior",
          today: "Hoy",
          yesterday: "Ayer",
          week: "Semana",
          day: "Día",
          agenda: "Agenda",
          allDay: "Todo el Día",
          date: "Fecha",
          time: "Hora",
          event: "Evento",
          showMore: "más",
        },
        tooltips: {
          edit: "Editar",
          delete: "Eliminar",
        },
      },
      tags: {
        title: "Etiquetas",
        confirmationModal: {
          deleteTitle: "¿Está seguro de que desea eliminar esta Etiqueta?",
          deleteMessage: "Esta acción no se puede deshacer.",
          deleteAllMessage: "¿Está seguro de que desea eliminar todas las Etiquetas?",
          deleteAllTitle: "Eliminar Todas",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Registros Etiquetados",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Etiqueta",
          deleteAll: "Eliminar Todas",
        },
        toasts: {
          deletedAll: "¡Todas las Etiquetas eliminadas con éxito!",
          deleted: "Etiqueta eliminada con éxito.",
        },
      },
      settings: {
        success: "Configuración guardada con éxito.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
      },
      settingsCustom: {
        tabs: {
          options: "Opciones",
          schedules: "Horarios",
          logo: "Logo",
          companies: "Empresas",
          newCompany: "Registrar Empresa",
          plans: "Planes",
          helps: "Ayuda",
        },
        toasts: {
          schedulesUpdated: "Horarios actualizados con éxito.",
        },
        uploader: {
          tab: {
            logosIcons: "Logos / Iconos",
          },
          labels: {
            chooseOption: "Elija una opción:",
            chooseImage: "Elija imagen PNG",
          },
          options: {
            signup: "Pantalla de Registro",
            login: "Pantalla de Login",
            interno: "Logo Interno",
            logoDark: "Logo Oscuro",
            favicon: "Favicon.Ico",
          },
          buttons: {
            sendFile: "ENVIAR ARCHIVO",
          },
          messages: {
            noPermission: "¡Sin permiso para acceder!",
            chooseFile: "¡Elija un archivo!",
            chooseDestination: "¡Elija un destino!",
            fileSentSuccess: "¡Archivo enviado con éxito!",
            invalidFileFormat: "¡Use solo archivos en formato PNG, ICO o SVG!",
          },
        },
      },
      settingsOptions: {
        labels: {
          ratings: "Evaluaciones",
          scheduleManagement: "Gestión de Horario Comercial",
          ignoreGroupMessages: "Ignorar Mensajes de Grupo",
          acceptCall: "Aceptar Llamada",
          chatbotType: "Tipo de Chatbot",
          sendGreetingAccepted: "Enviar saludo al aceptar ticket",
          sendTransferMessage: "Enviar mensaje de transferencia para Cola/agente",
          birthdayReminder: "Habilitar/Deshabilitar recordatorio de cumpleaños",
          holidayPeriod: "Habilitar/Deshabilitar mensaje de feriado/receso",
          holidayPeriodAllowQueueFlow: "La cola funciona incluso durante el receso",
          sendGreetingOneQueue: "Enviar saludo cuando solo hay 1 cola",
          viewClosedTickets: "¿Operador Ve Tickets Cerrados?",
          viewGroups: "¿Operador Ve Grupos?",
          allowRegister: "¿Registro (Signup) Permitido?",
          viewRegister: "¿Registro (Signup) Visible?",
          trialTime: "¿Tiempo de Prueba?",
          globalSettings: "Configuración Global",
          integrations: "INTEGRACIONES",
          asaas: "ASAAS",
          mercadoPago: "MERCADO PAGO",
          geminiAI: "GEMINI AI",
          paymentProvider: "Proveedor de pago",
          environment: "Entorno",
          webhookUrl: "URL Webhook",
          selectGeminiModel: "Seleccionar Modelo Gemini",
          geminiApiToken: "Token API Gemini",
        },
        options: {
          disabled: "Deshabilitado",
          enabled: "Habilitado",
          no: "No",
          yes: "Sí",
          scheduleDisabled: "Deshabilitado",
          scheduleQueue: "Cola",
          scheduleCompany: "Empresa",
          callDisabled: "No Aceptar",
          callEnabled: "Aceptar",
          chatbotText: "Texto",
          environmentProduction: "Producción",
          environmentSandbox: "Sandbox",
          paymentProviderGerencianet: "Gerencianet (Actual)",
          paymentProviderMercadoPago: "Mercado Pago",
        },
        placeholders: {
          greetingMessage: "Ej.: {{ms}} {{name}}, mi nombre es {{agent}} y procederé con su servicio.",
          transferMessage: "Ej.: {{ms}} {{name}}, su servicio fue transferido. Departamento: {{queue}}. Agente: {{agent}}.",
          birthdayMessage: "Ej.: ¡Felicidades {{name}}! 🎉🎂 ¡Te deseamos un feliz cumpleaños! ¡Que tengas {{idade}} años de mucha felicidad!",
          webhookUrl: "https://api.tuapp.com/subscription/webhook",
        },
        helperTexts: {
          updating: "Actualizando...",
          saving: "Guardando...",
          saveMessage: "Guardar mensaje",
          saveTime: "Guardar hora",
          greetingVariables: "Variables disponibles: {{ms}} (saludo), {{name}} (nombre contacto), {{agent}} (agente)",
          transferVariables: "Variables disponibles: {{ms}} (saludo), {{name}} (nombre contacto), {{agent}} (nuevo agente), {{queue}} (cola actual), {{previousAgent}} (agente anterior), {{previousQueue}} (cola anterior)",
          birthdayVariables: "Variables disponibles: {{name}} (nombre contacto), {{idade}} (edad contacto)",
          holidayPeriodFlow: "Cuando está habilitado, el flujo de cola continúa funcionando durante el receso, pero sin servicio",
          configureHolidayPeriod: "Configure períodos de feriado/receso en la configuración de conexión de WhatsApp",
          triggerTime: "Hora en que se enviarán los mensajes de cumpleaños (formato: HH:MM)",
          webhookUrlExample: "URL Webhook para validación. Ejemplo: https://api.tuapp.com/subscription/webhook",
          validatingWebhook: "Probando accesibilidad de URL...",
          validateWebhook: "Validar Webhook",
          gerencianetClientId: "ID de Cliente de aplicación Gerencianet",
          gerencianetClientSecret: "Secreto de Cliente de aplicación Gerencianet",
          gerencianetPixKey: "Clave PIX utilizada en cobros de Gerencianet",
          uploadingCert: "Subiendo certificado...",
          loadCert: "Cargar certificado (.p12)",
          certCurrent: "Certificado actual:",
          noCert: "Ningún certificado subido",
          mercadoPagoPublicKey: "Ingrese la clave pública de Mercado Pago",
          mercadoPagoAccessToken: "Ingrese el token de acceso de Mercado Pago",
          mercadoPagoWebhookSecret: "Firma secreta del webhook (se encuentra en el panel de Mercado Pago en 'Configurar Notificaciones Webhook' → campo 'Firma secreta')",
          mercadoPagoWebhookSecretOptional: "⚠️ Opcional, pero recomendado para mayor seguridad. Copie del campo \"Firma secreta\" en el panel de Mercado Pago.",
          geminiApiToken: "Configure el token API de Google Gemini para habilitar sugerencias automáticas de mensajes",
          geminiCurrentModel: "Modelo actual:",
          asaasToken: "Token Asaas",
        },
        messages: {
          greetingMessage: "Mensaje de saludo",
          transferMessage: "Mensaje de transferencia",
          birthdayMessage: "Mensaje de cumpleaños",
          triggerTime: "Hora de disparo",
        },
        toasts: {
          operationUpdated: "Operación actualizada con éxito.",
          greetingMessageUpdated: "Mensaje de saludo actualizado con éxito.",
          transferMessageUpdated: "Mensaje de transferencia actualizado con éxito.",
          birthdayReminderUpdated: "Recordatorio de cumpleaños actualizado con éxito.",
          birthdayMessageUpdated: "Mensaje de cumpleaños actualizado con éxito.",
          birthdayTimeUpdated: "Hora de disparo de cumpleaños actualizada con éxito. El sistema se reiniciará para aplicar los cambios.",
          holidayPeriodUpdated: "Mensaje de feriado/receso actualizado con éxito.",
          holidayPeriodFlowUpdated: "Configuración de flujo de receso actualizada con éxito.",
          gerencianetEnvironmentUpdated: "Entorno Gerencianet actualizado con éxito.",
          gerencianetClientIdUpdated: "ID de Cliente Gerencianet actualizado con éxito.",
          gerencianetClientSecretUpdated: "Secreto de Cliente Gerencianet actualizado con éxito.",
          gerencianetPixKeyUpdated: "Clave PIX Gerencianet actualizada con éxito.",
          gerencianetCertUploaded: "Certificado Gerencianet subido con éxito.",
          gerencianetCertWarning: "Certificado subido, pero no se pudo actualizar la configuración automáticamente.",
          gerencianetCertError: "No se pudo subir el certificado Gerencianet.",
          webhookUrlRequired: "Por favor ingrese la URL del webhook.",
          webhookValidated: "✅",
          webhookError: "❌",
          mercadoPagoPublicKeyUpdated: "Clave pública de Mercado Pago actualizada con éxito.",
          mercadoPagoAccessTokenUpdated: "Token de acceso de Mercado Pago actualizado con éxito.",
          mercadoPagoWebhookSecretUpdated: "Clave secreta de webhook de Mercado Pago actualizada con éxito.",
          paymentProviderUpdated: "Proveedor de pago actualizado con éxito.",
          geminiTokenUpdated: "Token Gemini actualizado con éxito.",
          certFormatError: "Envíe un certificado en formato .p12.",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Volver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            reject: "Rechazar",
            transfer: "Transferir",
            close: "Cerrar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escribe un mensaje",
        placeholderClosed: "Reabra o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        attachments: {
          image: "Imagen",
          document: "Documento",
          video: "Video",
          location: "Ubicación",
          audio: "Audio",
        },
      },
      mediaModal: {
        title: "Enviar Medios",
        caption: "Leyenda (opcional)",
        captionPlaceholder: "Escriba una leyenda para el archivo...",
        addMore: "Agregar más",
        dragDropText: "Suelte archivos aquí para enviar",
        buttons: {
          cancel: "Cancelar",
          send: "Enviar",
        },
        maxFiles: "Máximo 10 archivos permitidos",
      },
      messageSearch: {
        placeholder: "Buscar mensajes...",
        noResults: "No se encontraron mensajes",
        searchButton: "Buscar mensajes",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          cancel: "Cancelar",
          save: "Guardar",
        },
        extraInfo: "Otra información",
        contactNotes: "Notas del Contacto",
        note: "Nota",
        notePlaceholder: "Ingrese la información que desea registrar aquí",
        errors: {
          invalidUrl: "URL inválida:",
        },
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre de lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de opción",
        },
        success: "¡Lista de archivos guardada con éxito!",
      },
      ticketOptionsMenu: {
        schedule: "Agendar",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Notas del Contacto",
        appointmentsModal: {
          title: "Notas del Contacto",
          textarea: "Nota",
          placeholder: "Ingrese la información que desea registrar aquí",
        },
        confirmationModal: {
          title: "Eliminar ticket",
          titleFrom: "del contacto ",
          message: "¡Atención! Todos los mensajes relacionados con este ticket se perderán.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reactionSuccess: "Reacción agregada",
        reply: "Responder",
        edit: 'Editar Mensaje',
        forward: "Reenviar",
        toForward: "Reenviar",
        react: "Reaccionar",
        confirmationModal: {
          title: "¿Eliminar mensaje?",
          message: "Esta acción no se puede deshacer.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND: "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sesión de WhatsApp no se ha inicializado. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT: "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "No se pudo descargar medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Por favor intente nuevamente.",
        ERR_SENDING_WAPP_MSG: "Error enviando mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor inicie sesión.",
        ERR_USER_CREATION_DISABLED: "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tiene permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontró configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error creando mensaje en base de datos.",
        ERR_CREATING_TICKET: "Error creando ticket en base de datos.",
        ERR_FETCH_WAPP_MSG: "Error obteniendo mensaje de WhatsApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED: "El mensaje de bienvenida es obligatorio cuando hay más de una cola.",
        ERR_CHECK_NUMBER: "Número inválido. Verifique el número e intente nuevamente.",
      },

      queueOptions: {
        title: "Título no definido",
        placeholder: {
          optionText: "Escriba el texto de la opción",
          integrationUrl: "Escriba la URL de integración (N8N / TypeBOT ...)",
        },
        labels: {
          optionType: "Tipo de opción",
          selectQueue: "Seleccione una Cola",
          selectAttendant: "Seleccione un Agente",
        },
        types: {
          text: "Texto",
          attendant: "Agente",
          queue: "Cola",
          n8n: "Externo (API)",
        },
        buttons: {
          add: "Agregar",
          options: "Opciones",
        },
      },
      holidayPeriodManager: {
        title: "Receso/Feriados",
        buttons: {
          addPeriod: "Agregar Período",
          cancel: "Cancelar",
          save: "Guardar",
        },
        labels: {
          startDate: "Fecha de Inicio",
          endDate: "Fecha de Fin",
          message: "Mensaje",
          repeatInterval: "Repetir mensaje cada (horas)",
          active: "Activo",
        },
        placeholders: {
          message: "Ej.: Estamos en receso desde {{startDate}} hasta {{endDate}}. ¡Volveremos pronto!",
        },
        helperText: {
          variables: "Variables disponibles: {{startDate}} (fecha inicio), {{endDate}} (fecha fin), {{name}} (nombre contacto), {{ms}} (saludo)",
        },
        intervals: {
          hour1: "1 hora",
          hour2: "2 horas",
          hour3: "3 horas",
          hour6: "6 horas",
          hour12: "12 horas",
          hour24: "24 horas (1 día)",
          hour48: "48 horas (2 días)",
          hour72: "72 horas (3 días)",
        },
        dialog: {
          editTitle: "Editar Período",
          newTitle: "Nuevo Período de Receso/Feriado",
        },
        status: {
          active: "Activo",
          inactive: "Inactivo",
          activeNow: "⚠️ Período activo ahora",
        },
        dates: {
          from: "Desde:",
          to: "Hasta:",
        },
        messages: {
          noPeriods: "Ningún período de receso/feriado configurado",
          fillRequired: "Complete todos los campos obligatorios",
          dateError: "La fecha de inicio debe ser anterior a la fecha de fin",
          updated: "¡Período actualizado con éxito!",
          created: "¡Período creado con éxito!",
          deleted: "¡Período eliminado con éxito!",
          confirmDelete: "¿Está seguro de que desea eliminar este período?",
        },
      },
      campaignModal: {
        helperText: {
          variables: "Use variables como {name}, {number}, {email} o defina variables personalizadas.",
        },
        tabs: {
          message1: "Msg. 1",
          message2: "Msg. 2",
          message3: "Msg. 3",
          message4: "Msg. 4",
          message5: "Msg. 5",
        },
        errors: {
          generic: "Error procesando solicitud",
        },
      },
      toastError: {
        generic: "¡Ocurrió un error!",
      },
      backups: {
        title: "Respaldos del Sistema",
        buttons: {
          create: "Crear Respaldo",
          download: "Descargar",
          delete: "Eliminar",
          cancel: "Cancelar",
          previous: "Anterior",
          next: "Siguiente",
        },
        table: {
          name: "Nombre",
          size: "Tamaño",
          createdAt: "Fecha de Creación",
          actions: "Acciones",
        },
        placeholders: {
          search: "Buscar respaldos...",
        },
        status: {
          started: "Iniciado",
          preparing: "Preparando...",
          database: "Respaldando base de datos...",
          backend: "Respaldando backend...",
          frontend: "Respaldando frontend...",
          compressing: "Comprimiendo...",
          completed: "Completado",
          error: "Error",
        },
        messages: {
          noBackups: "No se encontraron respaldos",
          errorCreating: "Error creando respaldo:",
          unknownError: "Error desconocido",
          creating: "Creando Respaldo...",
          error: "Error:",
          important: "Importante:",
          importantNote: "Siempre se recomienda respaldar el VPS a través de snapshot y también realizar respaldos regularmente por la noche debido a la duración del proceso. Los respaldos incluyen la base de datos completa y todos los archivos del sistema (backend y frontend).",
          confirmDelete: "Confirmar Eliminación",
          confirmDeleteMessage: "¿Está seguro de que desea eliminar el respaldo \"{{name}}\"? Esta acción no afectará al sistema, solo eliminará el archivo de respaldo.",
          page: "Página",
          of: "de",
          databaseBackupError: "No se pudo respaldar la base de datos. Asegúrese de que mysqldump/pg_dump esté instalado.",
          tempDirNotFound: "Directorio temporal no encontrado para compresión",
          noFilesToCompress: "No se encontraron archivos para comprimir",
          zipCreationFailed: "Error al crear archivo ZIP",
          unsupportedDatabaseDialect: "Dialecto de base de datos no soportado",
        },
        toasts: {
          accessDenied: "Acceso denegado. Solo el superadmin puede acceder a esta página.",
          completed: "¡Respaldo completado con éxito!",
          started: "Respaldo iniciado. Por favor espere a que se complete...",
          deleted: "Respaldo eliminado con éxito",
          downloadStarted: "Descarga iniciada",
          error: "Error creando respaldo",
        },
        formatBytes: {
          zero: "0 Bytes",
          bytes: "Bytes",
          kb: "KB",
          mb: "MB",
          gb: "GB",
        },
      },
      chat: {
        noTicketMessage: "Seleccione un ticket para comenzar a chatear.",
        tabs: {
          chats: "Chats",
          messages: "Mensajes",
        },
        dialog: {
          title: "Conversación",
          labels: {
            title: "Título",
          },
          placeholders: {
            title: "Título",
          },
          alerts: {
            fillTitle: "Por favor complete el título de la conversación.",
            selectUser: "Por favor seleccione al menos un usuario.",
          },
          buttons: {
            close: "Cerrar",
            save: "Guardar",
          },
        },
        buttons: {
          new: "Nuevo",
          newChat: "Nuevo",
        },
        confirmationModal: {
          deleteTitle: "Eliminar Conversación",
          deleteMessage: "Esta acción no se puede deshacer, ¿confirmar?",
        },
      },
      campaignsConfig: {
        title: "Configuración de Campaña",
        sections: {
          intervals: "Intervalos",
        },
        toasts: {
          saved: "Configuración guardada",
        },
        labels: {
          randomInterval: "Intervalo de Envío Aleatorio",
          greaterInterval: "Intervalo de Envío Mayor",
          greaterIntervalAfter: "Intervalo Mayor Después de",
          shortcut: "Atajo",
          content: "Contenido",
        },
        intervals: {
          noInterval: "Sin Intervalo",
          notDefined: "No definido",
          seconds: "segundos",
          second: "segundo",
        },
        buttons: {
          addVariable: "Agregar Variable",
          saveSettings: "Guardar Configuración",
          close: "Cerrar",
          add: "Agregar",
        },
        table: {
          shortcut: "Atajo",
          content: "Contenido",
        },
      },
      campaignReport: {
        titles: {
          validContacts: "Contactos Válidos",
          requestedConfirmations: "Confirmaciones Solicitadas",
          confirmations: "Confirmaciones",
          delivered: "Entregado",
          connection: "Conexión",
          contactList: "Lista de Contactos",
          scheduled: "Programación",
          completion: "Finalización",
        },
      },

      contactListItems: {
        tooltips: {
          validWhatsapp: "Whatsapp Válido",
          invalidWhatsapp: "Whatsapp Inválido",
        },
      },
      announcementModal: {
        validation: {
          titleRequired: "Requerido",
          textRequired: "Requerido",
        },
      },
      financeiro: {
        title: "Facturas",
        table: {
          id: "Id",
          details: "Detalles",
          value: "Valor",
          dueDate: "Fecha de Vencimiento",
          status: {
            label: "Estado",
            paid: "Pagado",
            overdue: "Vencido",
            open: "Abierto",
          },
          action: "Acción",
        },
        buttons: {
          pay: "PAGAR",
          paid: "PAGADO",
        },
      },
      checkoutPage: {
        title: "¡Casi listo!",
        steps: {
          data: "Datos",
          customize: "Personalizar",
          review: "Revisar",
        },
        buttons: {
          back: "VOLVER",
          next: "SIGUIENTE",
          pay: "PAGAR",
        },
        addressForm: {
          title: "Necesitaremos alguna información",
        },
        paymentForm: {
          month: "/mes",
          users: "Usuarios",
          connections: "Conexión",
          queues: "Colas",
          select: "SELECCIONAR",
        },
        reviewOrder: {
          title: "Resumen de suscripción",
          planDetails: {
            title: "Detalles del plan",
            users: "Usuarios:",
            whatsapps: "Whatsapps:",
            billing: "Facturación: Mensual",
            total: "Total:",
          },
          paymentInfo: {
            title: "Información de pago",
            email: "Email:",
            name: "Nombre:",
            address: "Dirección:",
            total: "Total:",
          },
        },
        checkoutSuccess: {
          total: "TOTAL",
          emailForBilling: "Email para facturación:",
          copyPix: "Copiar PIX",
          copied: "Copiado",
          instructions: "Para finalizar, solo realice el pago escaneando o pegando el código Pix arriba :)",
          licenseRenewed: "¡Su licencia ha sido renovada hasta {{date}}!",
        },
        toasts: {
          subscriptionSuccess: "¡Suscripción completada con éxito!, esperando pago",
        },
        formModel: {
          firstName: {
            label: "Nombre completo*",
            requiredErrorMsg: "Nombre completo es obligatorio",
          },
          lastName: {
            label: "Apellido*",
            requiredErrorMsg: "Apellido es obligatorio",
          },
          address1: {
            label: "Dirección*",
            requiredErrorMsg: "Dirección es obligatoria",
          },
          city: {
            label: "Ciudad*",
            requiredErrorMsg: "Ciudad es obligatoria",
          },
          state: {
            label: "Estado*",
            requiredErrorMsg: "Estado es obligatorio",
          },
          zipcode: {
            label: "Código Postal*",
            requiredErrorMsg: "Código Postal es obligatorio",
            invalidErrorMsg: "Formato de Código Postal inválido",
          },
          country: {
            label: "País*",
            requiredErrorMsg: "País es obligatorio",
          },
          nameOnCard: {
            label: "Nombre en la tarjeta*",
            requiredErrorMsg: "Nombre en la tarjeta es obligatorio",
          },
          cardNumber: {
            label: "Número de tarjeta*",
            requiredErrorMsg: "Número de tarjeta es obligatorio",
            invalidErrorMsg: "Número de tarjeta inválido (ej.: 4111111111111)",
          },
          expiryDate: {
            label: "Fecha de vencimiento*",
            requiredErrorMsg: "Fecha de vencimiento es obligatoria",
            invalidErrorMsg: "Fecha de vencimiento inválida",
          },
          cvv: {
            label: "CVV*",
            requiredErrorMsg: "CVV es obligatorio",
            invalidErrorMsg: "CVV inválido (ej.: 357)",
          },
          useAddressForPaymentDetails: {
            label: "Usar esta dirección para detalles de pago",
          },
          invoiceId: {
            label: "Usar este invoiceId",
          },
        },
      },
      companiesManager: {
        labels: {
          recurrence: "Recurrencia",
        },
        status: {
          no: "No",
          yes: "Sí",
        },
        toasts: {
          loadError: "No se pudo cargar la lista de registros",
          success: "¡Operación realizada con éxito!",
          operationError: "No se pudo realizar la operación. Verifique si ya existe una empresa con el mismo nombre o si los campos se completaron correctamente",
        },
        confirmationModal: {
          deleteTitle: "Eliminación de Registro",
        },
      },
      contactNotesDialog: {
        toasts: {
          added: "¡Nota agregada con éxito!",
          deleted: "¡Nota eliminada con éxito!",
        },
      },
      messageInputCustom: {
        errors: {
          locationError: "Error obteniendo ubicación: ",
          geolocationNotSupported: "Geolocalización no soportada por el navegador",
          maxFiles: "Máximo 100 archivos permitidos",
        },
        labels: {
          video: "Video",
          location: "Ubicación",
        },
      },
      campaignReport: {
        titles: {
          validContacts: "Contactos Válidos",
          requestedConfirmations: "Confirmaciones Solicitadas",
          confirmations: "Confirmaciones",
          delivered: "Entregado",
          connection: "Conexión",
          contactList: "Lista de Contactos",
          scheduled: "Horario",
          completion: "Finalización",
        },
      },
      pages: {
        toasts: {
          noPermission: "¡Esta empresa no tiene permiso para acceder a esta página! Lo estamos redirigiendo.",
        },
        errors: {
          getTicketsInfo: "Error obteniendo información del ticket",
          getConversationInfo: "Error obteniendo información de la conversación",
        },
      },
      dashboard: {
        cards: {
          activeConnections: "Conexiones Activas",
          companies: "Empresas",
          inConversation: "En Conversación",
          waiting: "Esperando",
          newContacts: "Nuevos Contactos",
          avgConversationTime: "Tiempo Prom. Conversación",
          finished: "Finalizados",
          avgWaitTime: "Tiempo Prom. Espera",
        },
        filters: {
          filterType: "Tipo de Filtro",
          dateFilter: "Filtro de Fecha",
          periodFilter: "Filtro de Período",
          startDate: "Fecha de Inicio",
          endDate: "Fecha de Fin",
          period: "Período",
          noneSelected: "Ninguno seleccionado",
          last3Days: "Últimos 3 días",
          last7Days: "Últimos 7 días",
          last15Days: "Últimos 15 días",
          last30Days: "Últimos 30 días",
          last60Days: "Últimos 60 días",
          last90Days: "Últimos 90 días",
          filter: "Filtrar",
          configureFilter: "Configurar el filtro",
        },
        table: {
          name: "Nombre",
          ratings: "Evaluaciones",
          avgServiceTime: "Tiempo Prom. Servicio",
          currentStatus: "Estado (Actual)",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
          user: {
            title: "Gráfico de Conversaciones",
            totalConversationsByUsers: "Total de Conversaciones por Usuarios",
          },
          date: {
            total: "Total",
            title: "Gráfico de Conversaciones",
            error: "Error obteniendo información de tickets",
          },
          appointmentsAtendent: {
            label: "Número de Tickets",
            title: "Tickets por Atendentes",
            description: "Descubra qué atendentes son más productivos",
            byDepartments: "Tickets por Departamentos/Colas",
            departmentsDescription: "Descubra qué departamentos son los más solicitados",
          },
          rushHour: {
            title: "Horas Pico - Intercambio de Mensajes",
            description: "Número de mensajes recibidos y enviados cada hora del día.",
            hourOfDay: "Hora del Día",
            quantity: "Cantidad",
          },
          departamentRatings: {
            title: "Evaluaciones por Departamento/Cola",
            description: "Vea las evaluaciones promedio para cada departamento/cola.",
            quantity: "Cantidad",
          },
          dateLabels: {
            start: "Inicio",
            end: "Fin",
          },
          common: {
            filter: "Filtrar",
            quantity: "Cantidad",
          },
        },
      },
      announcementModal: {
        form: {
          sendToAllCompanies: "Enviar a todas las empresas",
          showToSuperadmin: "Mostrar al superadmin",
          sendToAllCompaniesDesc: "Cuando está habilitado, el anuncio se enviará a todas las empresas registradas",
          showToSuperadminDesc: "Cuando está deshabilitado, el anuncio no se mostrará a los superadmins",
        },
        buttons: {
          preview: "Vista previa",
        },
        toasts: {
          successAllCompanies: "¡Anuncio enviado con éxito a {{count}} {{count, plural, one {empresa} other {empresas}}}!",
        },
      },
      kanban: {
        open: "Abierto",
        tooltips: {
          notes: "Notas",
          createSchedule: "Crear cita",
          goToConversation: "Ir a la conversación",
        },
        menu: {
          finalize: "Finalizar",
        },
        dialog: {
          unlinkTicket: "Desvincular Ticket",
          deleteTicket: "Eliminar Ticket",
          unlinkMessage: "¿Está seguro de que desea desvincular este ticket de todas las etiquetas kanban? El chat permanecerá intacto.",
          deleteMessage: "Advertencia: Esta acción es irreversible. Todos los mensajes se perderán.",
          cancel: "Cancelar",
          confirm: "Confirmar",
        },
      },
      emojiGifStickerPicker: {
        searchGifs: "Buscar GIFs",
        stickers: {
          selectStickers: "Seleccione los stickers",
          selected_one: "{{count}} sticker seleccionado",
          selected_other: "{{count}} stickers seleccionados",
          selectAll: "Seleccionar Todos",
          clear: "Limpiar",
          delete: "Eliminar ({{count}})",
          noStickers: "Sin stickers guardados. Haga clic en + para agregar.",
          deleteStickerTitle: "Eliminar Sticker",
          deleteStickerMessage: "¿Realmente desea eliminar este sticker?",
          deleteMultipleTitle: "Eliminar Stickers Seleccionados",
          deleteMultipleMessage: "¿Realmente desea eliminar {{count}} sticker(s) seleccionado(s)? Esta acción no se puede deshacer.",
          loadError: "Error cargando",
        },
      },
      legal: {
        back: "Volver al registro",
        privacy: {
          title: "Política de Privacidad",
          lastUpdate: "Última actualización",
          s1: {
            title: "1. Introducción",
            content: "Esta Política de Privacidad descreve como coletamos, usamos e protegemos suas informações ao utilizar nossa plataforma SaaS de atendimento via WhatsApp. Estamos comprometidos em garantir a proteção da sua privacidade e o cumprimento da Lei Geral de Proteção de Dados (LGPD) e leis locais.",
          },
          s2: {
            title: "2. Coleta de Dados",
            content: "Coletamos informações necessárias para a prestação dos nossos serviços, incluindo:",
            items: [
              "Informações de cadastro (nome, e-mail, telefone, empresa).",
              "Dados de autenticação e logs de acesso.",
              "Conteúdo das mensagens processadas através da nossa API (estritamente para finalidade de atendimento).",
              "Cookies e dados de navegação para melhorar a experiência do usuário.",
            ],
          },
          s3: {
            title: "3. Uso das Informações",
            content: "Os dados coletados são utilizados para:",
            items: [
              "Gerenciar sua conta e fornecer suporte técnico.",
              "Processar e organizar seus atendimentos via WhatsApp.",
              "Garantir a segurança da plataforma e prevenir fraudes.",
              "Enviar comunicações importantes sobre o sistema e atualizações.",
            ],
          },
          s4: {
            title: "4. Segurança dos Dados",
            content: "Implementamos medidas técnicas e organizacionais rigorosas para proteger seus dados contra acesso não autorizado, alteração, divulgação ou destruição. Isso inclui criptografia de dados em repouso e em trânsito, firewalls e auditorias regulares de segurança.",
          },
          s5: {
            title: "5. Compartilhamento de Informações",
            content: "Não vendemos seus dados pessoais a terceiros. O compartilhamento ocorre apenas quando necessário para a operação do serviço (ex: provedores de infraestrutura em nuvem) ou por exigência legal.",
          },
          s6: {
            title: "6. Seus Direitos",
            content: "De acordo com a LGPD, você possui o direito de:",
            items: [
              "Confirmar a existência de tratamento de seus dados.",
              "Acessar seus dados pessoais armazenados por nós.",
              "Corrigir dados incompletos ou inexatos.",
              "Solicitar a anonimização ou exclusão de dados desnecessários.",
              "Revogar seu consentimento a qualquer momento.",
            ],
          },
          s7: {
            title: "7. Contato",
            content: "Se você tiver dúvidas sobre esta Política de Privacidade ou sobre como tratamos seus dados, entre em contato com nosso Encarregado de Dados (DPO) através do suporte do sistema.",
          },
        },
        terms: {
          title: "Términos de Servicio",
          lastUpdate: "Última atualização",
          s1: {
            title: "1. Aceitação dos Termos",
            content: "Ao se cadastrar e utilizar nossa plataforma, você concorda em cumprir estes Termos de Serviço. Se você não concordar com qualquer parte destes termos, não poderá acessar ou utilizar o serviço.",
          },
          s2: {
            title: "2. Descrição do Serviço",
            content: "Fornecemos uma solução SaaS para gerenciamento de atendimento multicanal via WhatsApp. O serviço inclui interface de chat, gestão de tickets, relatórios e automações. Reservamo-nos o direito de atualizar ou modificar recursos da plataforma para melhoria contínua.",
          },
          s3: {
            title: "3. Responsabilidades do Usuário",
            content: "O usuário compromete-se a:",
            items: [
              "Fornecer informações precisas e mantê-las atualizadas.",
              "Utilizar o serviço em conformidade com as políticas oficiais do WhatsApp/Meta.",
              "Não utilizar a plataforma para envio de spam, conteúdo ilegal ou abusivo.",
              "Manter a confidencialidade de suas credenciais de acesso.",
            ],
          },
          s4: {
            title: "4. Pagamentos e Assinaturas",
            content: "O acesso ao sistema é baseado em planos de assinatura. O atraso no pagamento pode resultar na suspensão temporária ou cancelamento dos serviços. Valores e taxas podem ser reajustados mediante aviso prévio.",
          },
          s5: {
            title: "5. Propriedade Intelectual",
            content: "Todo o código-fonte, design, logotipos e conteúdo da plataforma são de propriedade exclusiva da nossa empresa ou licenciadores. É proibida a engenharia reversa ou reprodução não autorizada do sistema.",
          },
          s6: {
            title: "6. Limitação de Responsabilidade",
            content: "Não nos responsabilizamos por interrupções causadas por falhas na infraestrutura de terceiros (como o próprio WhatsApp ou provedores de internet) ou pelo uso inadequado da plataforma pelo usuário que resulte em banimento de números junto à Meta.",
          },
          s7: {
            title: "7. Rescisão",
            content: "Você pode cancelar sua conta a qualquer momento através do painel financeiro. Reservamo-nos o direito de encerrar contas que violem de forma grave estes termos de uso.",
          },
          s8: {
            title: "8. Alterações nos Termos",
            content: "Podemos revisar estes termos periodicamente. Alterações significativas serão notificadas através do sistema ou por e-mail. O uso continuado após as alterações constitui aceitação dos novos termos.",
          },
        },
      },
      dashboard: {
        cards: {
          activeConnections: "Conexiones Activas",
          companies: "Empresas",
          inConversation: "En Conversación",
          waiting: "Esperando",
          newContacts: "Nuevos Contactos",
          avgConversationTime: "T.M. de Conversación",
          finished: "Finalizados",
          avgWaitTime: "T.M. de Espera",
        },
        filters: {
          filterType: "Tipo de Filtro",
          dateFilter: "Filtro por Fecha",
          periodFilter: "Filtro por Período",
          dateFrom: "Fecha Inicial",
          dateTo: "Fecha Final",
          period: "Período",
          noneSelected: "Ninguno seleccionado",
          last3Days: "Últimos 3 días",
          last7Days: "Últimos 7 días",
          last15Days: "Últimos 15 días",
          last30Days: "Últimos 30 días",
          last60Days: "Últimos 60 días",
          last90Days: "Últimos 90 días",
          filter: "Filtrar",
        },
        messages: {
          parameterizeFilter: "Parametrizar el filtro",
        },
        charts: {
          ticketsCreated: "Tickets Creados: ",
          tickets: "Tickets",
          conversationsChart: "Gráfico de Conversaciones",
          quantity: "Cantidad",
          hourOfDay: "Hora del Día",
          errorLoadingData: "Error al cargar datos de conversación",
        },
      },
    },
  },
};

export { messages };